<template>
    <div>
      <b-card>
        <b-row>
          <b-col cols="2" class="text-sm-left">
            <b>Id:</b>  {{licencia.Id}}
          </b-col>
          <b-col cols="5" class="text-sm-right">
            <b>Operador :</b>
            {{ licencia.UsuarioCargaString}}
          </b-col>
          <b-col cols="5" class="text-sm-right">
            <b>Fecha autorización :</b>
            {{ licencia.FechaCreacion | moment("DD-MM-YYYY")}}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="text-sm-left">
            <b>Artículo:</b>  {{licencia.TipoLicencia.Articulo}} {{licencia.TipoLicencia.Descripcion}}
          </b-col>
          <b-col cols="6" class="text-sm-left">
            <b>Instancia art.:</b> {{ licencia.DetalleDiasLicencia.Descripcion }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="text-sm-left" v-if="licencia.CIE10String !== 'NULL'">
            <b variant="danger">Diagnóstico (CIE10) :</b>
            {{ licencia.CIE10String ? licencia.CIE10String : 'Sin diagnóstico' }}
          </b-col>
          <b-col cols="6" class="text-sm-left">
            <b>Observaciones :</b>
            {{ licencia.Observaciones }}
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2">
            <b variant="danger">Días otorgados :</b>
            <small>{{ licencia.CantidadDias }}</small>
          </b-col>
          <b-col cols="3">
            <b variant="danger">Desde :</b>
            <small>{{ licencia.LicenciaDesde | moment("DD-MM-YYYY") }}</small>
          </b-col>
          <b-col cols="2">
            <b variant="danger">Hasta :</b>
            <small>{{ licencia.LicenciaHasta | moment("DD-MM-YYYY") }}</small>
          </b-col>
          <b-col cols="2">
            <b variant="danger">Días restantes :</b>
            <small>{{ licencia.CantidadDiasRestantes }}</small>
          </b-col>
          <b-col cols="3">
            <b variant="danger">Días consumidos :</b>
            <b-progress :max="licencia.CantidadDias">
              <b-progress-bar :value="licencia.CantidadDiasConsumidos ">
                <span><strong>{{ licencia.CantidadDiasConsumidos }} / {{ licencia.CantidadDias }}</strong></span>
              </b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
        <b-row v-if="incluyesolicitud">
          <b-col cols="3">
            <b>Solicitud :</b>
            <small>{{ licencia.SolicitudMedica.Id }}</small>
          </b-col>
          <b-col cols="3">
            <b>Tipo solicitud :</b>
            <small>{{ licencia.SolicitudMedica.TipoSolicitudMedicaString }}</small>
          </b-col>
          <b-col cols="3">
            <b>Fcha solicitud :</b>
            <small>{{ licencia.SolicitudMedica.FechaPresentacion | moment("DD-MM-YYYY") }}</small>
          </b-col>
          <b-col cols="3">
            <b>Operador :</b>
            <small>{{ licencia.SolicitudMedica.UsuarioCargaString }}</small>
          </b-col>
        </b-row>
        <b-row v-if="incluyesolicitud">
          <b-col cols="12">
            <b>Cargos :</b>
            <tabla-base detallerender="cargopersonal" :items="licencia.ListaCargoPersonal" :fields="tablacargopersonal.fields"></tabla-base>
          </b-col>
        </b-row>
      </b-card>
    </div>
</template>

<script>
import TablaBase from "../common/TablaBase.vue";
import constantes from '@/constantes'
export default {
  name: 'CardDetalleLicencia',
  props: {
    licencia: Object,
    incluyesolicitud: Boolean
  },
  components: { TablaBase },
  data() {
    return {
      tablacargopersonal: constantes.tablacargos
    };
  },
}
</script>




// WEBPACK FOOTER //
// src/components/common/CardDetalleLicencia.vue